<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <campaign-form
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></campaign-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import CampaignForm from '../../components/campaign/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      CampaignForm
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Campaign'
        }

        return 'Create Campaign'
      },
    },
    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-campaign-table');
      },
    },

    created() {
      eventBus.$on('show-add-campaign-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-campaign-dialog', this.show);
    }
  }
</script>
